<div class="cliente-segmento-card-chart">
    <div class="cliente-segmento-card-chart-header">
        {{nome}}
    </div>
    <div class="cliente-segmento-card-chart-body">
        <h4 class="cliente-segmento-card-title">
            {{quantidadeClientes | decimalFormat:1:0:0}}
            <small class="cliente-segmento-card-subtitle" *ngIf="percParticipacao">
                ({{percParticipacao | decimalFormat:1:2:2}}%)
            </small>
        </h4>
    </div> 
</div>